import Swal from 'sweetalert2';
export const showAlert = async (error, title) => {
  const swalResult = await Swal.fire({
    title: title,
    text: error,
    icon: 'error',
    confirmButtonText: 'Okay',
    customClass: 'sweetalert-bootstrap-modal',
    timer: 4000,
    showConfirmButton: false
  });

  // If you want to perform some action after the alert is closed, you can check the result
  if (swalResult.dismiss === Swal.DismissReason.timer) {
    // console.log('Alert closed after the timer elapsed.');
    // Perform additional actions if needed
  }
};

export const showOkAlert = async (error, title) => {
  return Swal.fire({
    title,
    text: error,
    icon: 'error',
    confirmButtonText: 'OK',
    showConfirmButton: true,
    allowOutsideClick: false,
    customClass: 'sweetalert-bootstrap-modal'
  });
};

export const showAlertLong = async (error, title) => {
  const swalResult = await Swal.fire({
    title: title,
    text: error,
    icon: 'error',
    confirmButtonText: 'Okay',
    customClass: 'sweetalert-bootstrap-modal',
    timer: 3000,
    showConfirmButton: false
  });

  // If you want to perform some action after the alert is closed, you can check the result
  if (swalResult.dismiss === Swal.DismissReason.timer) {
    // console.log('Alert closed after the timer elapsed.');
    // Perform additional actions if needed
  }
};
